export const AgeRating = ({ ageRating }: { ageRating: string }) => {
  return (
    <span className="min-w-6 rounded-md border px-2 text-center w-fit">
      {ageRating}
    </span>
  );
};
